import { createContext, useContext, useEffect, useState } from "react";
import { COPY } from "@/data/content";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(
    () => window.localStorage.getItem("fafapiti-lang") || "fr"
  );

  useEffect(() => {
    window.localStorage.setItem("fafapiti-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const value = { lang, setLang, t: COPY[lang] };
  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
